import { render, staticRenderFns } from "./RegionDropdown.vue?vue&type=template&id=dcdcd386&scoped=true&"
import script from "./RegionDropdown.vue?vue&type=script&lang=js&"
export * from "./RegionDropdown.vue?vue&type=script&lang=js&"
import style0 from "./RegionDropdown.vue?vue&type=style&index=0&id=dcdcd386&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcdcd386",
  null
  
)

export default component.exports